import { Component, inject, Input, OnInit } from '@angular/core';
import { FinancialProductEnum } from '../../model/standard-quote.model';
import { TrackerService } from '@app/services/tracker.service';

@Component({
  template: ''
})
export class ViewDealStandardQuoteWrapperComponent {
  private trackerService = inject(TrackerService);
  showSection: number = 1;
  @Input() payments: any[];
  @Input() specialPayments: any[];
  @Input() grace: any[];
  @Input() id: any;
  @Input() idDeal: any;
  @Input() financialProduct: FinancialProductEnum;
  @Input() currency: string;
  @Input() insurance: any;

  selectSection(index: number) {
    this.showSection = index;
    this.trackerService.track("UserChangeQuoteDealTab", {
      quoteId: this.id,
      tabSelected: index
    });
  }

  get isPureLeasing(){
    return this.financialProduct === FinancialProductEnum.pureLease;
  }

  get insurancePayments() {
    return this.insurance?.standardQuoteInsurancePayments || [];
  }

  get isAvailableInsurancePayments(){
    const payments = this.insurance?.standardQuoteInsurancePayments || [];
    return payments?.length > 0;
  }

  get isInsuranceCalculated(){
    return this.insurance?.id != null;
  }
}
